import { PropsWithChildren, ReactElement, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';

type ProtectedRouteProps = PropsWithChildren<{}>;

const ProtectedRoute = ({
  children,
}: ProtectedRouteProps): ReactElement | null => {
  const { isLoggedIn, getLoggedUser } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const logged = await getLoggedUser();
      if (!logged) {
        navigate('/login', { replace: true });
      }
    })();
  }, [navigate, isLoggedIn]);

  // Verifica se está logado antes de decidir renderizar os children
  return isLoggedIn ? <>{children}</> : null;
};

export default ProtectedRoute;
